import { FC, Fragment } from "react"
import { Box } from "@mui/material"
import { Component } from '../../types/ContentStructure'
import ComponentIconoItem from './ComponentIconoItem'

interface IComponentIconosReguladoresProps {
    component: Component
}

const ComponentIconosReguladores: FC<IComponentIconosReguladoresProps> = ({ component }) => {
    const { image, imageMd, imageXs, components = [], theme } = component

    const bgXs = imageXs || image
    const bgMd = imageMd || image
    const bgLg = image
    const backgroundColor = theme?.themeStyles?.backgroundColor
    const dividerGradient = {
        xs: "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.72) 50%, rgba(255,255,255,0) 100%)",
        md: "linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.72) 50%, rgba(255,255,255,0) 100%)",
    }

    return (
        <Box sx={{
            width: '100%',
            backgroundImage: `url(${bgXs})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            px: { xs: 2, sm: 3, md: 3, lg: 4 },
            py: { xs: 5, sm: 5.5, md: 2.5, lg: 3 },
            backgroundColor,
            mt: -3,
            position: 'relative',
            zIndex: 999
        }}>
            <Box sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                flexWrap: 'nowrap',
                alignItems: 'stretch',
                gap: { xs: 3, md: 0 },
                width: '100%',
                justifyContent: 'space-around',
                mx: 'auto',
            }}>
                {components.map((item: Component, index: number) => {
                    const isCenter = index === 1

                    return (
                        <Fragment key={item.id || index}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'stretch',
                                    justifyContent: 'center',
                                    minWidth: 0,
                                }}
                            >
                                <ComponentIconoItem
                                    component={item}
                                    layout={isCenter ? 'center' : 'side'}
                                />
                            </Box>
                            {index < components.length - 1 && (
                                <Box
                                    aria-hidden="true"
                                    sx={{
                                        flexShrink: 0,
                                        alignSelf: 'center',
                                        width: { xs: '100%', md: '1px' },
                                        height: { xs: '1px', md: '160px', lg: '160px' },
                                        mx: 0,
                                        backgroundImage: dividerGradient,
                                    }}
                                />
                            )}
                        </Fragment>
                    )
                })}
            </Box>
        </Box>
    )
}

export default ComponentIconosReguladores
